import { useId } from "react";
import {
  ITEM_OVERRIDE_SELECTION_FIELDS,
  type ItemOverrideFieldSelection,
} from "@forgepoint/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { ITEM_OVERRIDE_FIELD_LABELS } from "@/modules/quotes/itemOverrideFieldLabels";

interface ItemOverrideFieldTogglesProps {
  value: ItemOverrideFieldSelection;
  onChange: (next: ItemOverrideFieldSelection) => void;
  disabled: boolean;
  showAllowance: boolean;
}

/**
 * One switch per field a quote line may override.
 * The allowance switch shows only while the item setting enables allowance.
 */
export function ItemOverrideFieldToggles({
  value,
  onChange,
  disabled,
  showAllowance,
}: ItemOverrideFieldTogglesProps) {
  const idPrefix = useId();
  const fields = ITEM_OVERRIDE_SELECTION_FIELDS.filter(
    (field) => field !== "allowance" || showAllowance,
  );

  return (
    <div className="ml-1 max-w-xs space-y-2 border-l pl-4">
      <p className="text-xs font-medium text-muted-foreground">
        Fields a line can override
      </p>
      {fields.map((field) => {
        const switchId = `${idPrefix}-${field}`;
        return (
          <div key={field} className="flex items-center justify-between gap-4">
            <Label htmlFor={switchId} className="text-sm font-normal">
              {ITEM_OVERRIDE_FIELD_LABELS[field]}
            </Label>
            <Switch
              id={switchId}
              checked={value[field]}
              onCheckedChange={(checked) =>
                onChange({ ...value, [field]: checked })
              }
              disabled={disabled}
            />
          </div>
        );
      })}
    </div>
  );
}
